(function () {
  var KEY = 'wishlist';
  var set = new Set(read());
  var saveTimer;

  function read() {
    try {
      var a = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(a) ? a : [];
    } catch (e) { return []; }
  }

  function save() {
    clearTimeout(saveTimer);
    try { localStorage.setItem(KEY, JSON.stringify(Array.from(set))); } catch (e) {}
  }
  function saveSoon() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(save, 0);
  }

  function btnSel(handle) {
    var h = window.CSS && CSS.escape ? CSS.escape(handle) : handle;
    return '.wt-button[data-product-handle="' + h + '"]';
  }

  function paint(handle, on) {
    var list = document.querySelectorAll(btnSel(handle));
    for (var i = 0; i < list.length; i++) list[i].classList.toggle('active', on);
  }

  function paintAll() {
    var list = document.querySelectorAll('.wt-button');
    for (var i = 0; i < list.length; i++) {
      list[i].classList.toggle('active', set.has(list[i].dataset.productHandle));
    }
  }

  function updateCount() {
    var el = document.getElementById('wt-count');
    if (!el) return;
    var n = set.size;
    if (n > 0) {
      el.textContent = n;
      el.style.display = 'flex';
    } else {
      el.textContent = '';
      el.style.display = 'none';
    }
  }

  /* quiet = the change came from the wishlist drawer (it updates itself) */
  function put(handle, on, quiet) {
    if (!handle || set.has(handle) === on) return false;
    if (on) set.add(handle); else set.delete(handle);
    paint(handle, on);
    updateCount();
    saveSoon();
    document.dispatchEvent(new CustomEvent('gm:wishlist', { detail: { handle: handle, added: on, quiet: !!quiet } }));
    return true;
  }

  window.gmWishlist = {
    has: function (h) { return set.has(h); },
    list: function () { return Array.from(set); },
    size: function () { return set.size; },
    set: put
  };

  paintAll();
  updateCount();

  // One delegated listener for all current + future wishlist buttons.
  // Runs before the page-wide tracking click listeners; the heart flips first, the rest follows after the paint.
  window.addEventListener('click', function (e) {
    var button = e.target.closest && e.target.closest('.wt-button');
    if (!button) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var handle = button.dataset.productHandle;
    if (!handle) return;

    var added = !button.classList.contains('active');
    button.classList.toggle('active', added);

    requestAnimationFrame(function () {
      setTimeout(function () {
        put(handle, added, false);
      }, 0);
    });
  }, true);

  // Another tab changed the wishlist
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY) return;
    set = new Set(read());
    paintAll();
    updateCount();
    document.dispatchEvent(new CustomEvent('gm:wishlist', { detail: { handle: null, added: null, quiet: false } }));
  });

  window.addEventListener('pagehide', save);

  // cards added after the page loaded (infinite scroll, section reloads) get their saved hearts too
  var paintTimer;
  new MutationObserver(function () {
    clearTimeout(paintTimer);
    paintTimer = setTimeout(paintAll, 200);
  }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });

  var gmWlToast, gmWlTimer, gmWlHide;
  var HEART_ON = '<svg viewBox="0 0 24 24" width="16" height="16" fill="#ff4d7d" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.8 8.2 2.9 4.5 6.5 4.5c2 0 3.5 1 4.5 2.4 1-1.4 2.5-2.4 4.5-2.4 3.6 0 5.7 3.7 4.1 7.3C19.5 16.4 12 21 12 21z"/></svg>';
  var HEART_OFF = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="#bdbdbd" stroke-width="2" stroke-linejoin="round" aria-hidden="true"><path d="M12 21s-7.5-4.6-9.6-9.2C.8 8.2 2.9 4.5 6.5 4.5c2 0 3.5 1 4.5 2.4 1-1.4 2.5-2.4 4.5-2.4 3.6 0 5.7 3.7 4.1 7.3C19.5 16.4 12 21 12 21z"/></svg>';

  function showNotification(message) {
    var added = /^added/i.test(message);
    if (!gmWlToast) {
      gmWlToast = document.createElement('div');
      gmWlToast.setAttribute('role', 'status');
      gmWlToast.setAttribute('aria-live', 'polite');
      gmWlToast.style.cssText =
        'position:fixed;left:50%;bottom:calc(96px + env(safe-area-inset-bottom,0px));' +
        'transform:translate(-50%,8px);z-index:40;display:none;align-items:center;gap:8px;' +
        'padding:10px 16px;border-radius:999px;background:#1c1c1c;color:#fff;' +
        'font-size:13px;font-weight:500;line-height:1;white-space:nowrap;max-width:92vw;' +
        'box-shadow:0 4px 14px rgba(0,0,0,.22);pointer-events:none;opacity:0;' +
        'transition:opacity .2s ease,transform .2s ease;';
      document.body.appendChild(gmWlToast);
    }
    gmWlToast.innerHTML = (added ? HEART_ON : HEART_OFF) + '<span>' + (added ? 'Added to wishlist' : 'Removed from wishlist') + '</span>';
    clearTimeout(gmWlTimer);
    clearTimeout(gmWlHide);
    gmWlToast.style.display = 'flex';
    requestAnimationFrame(function () {
      gmWlToast.style.opacity = '1';
      gmWlToast.style.transform = 'translate(-50%,0)';
    });
    gmWlTimer = setTimeout(function () {
      gmWlToast.style.opacity = '0';
      gmWlToast.style.transform = 'translate(-50%,8px)';
      gmWlHide = setTimeout(function () { gmWlToast.style.display = 'none'; }, 250);
    }, 2000);
  }
})();